import AttachmentsGrid from './AttachmentsGrid';

export default AttachmentsGrid;
